import React from 'react';

var HeaderColumn = function (_a) {
    var children = _a.children, popupRef = _a.popupRef;
    return (React.createElement("div", { className: 'pgc-header-column', ref: popupRef }, children));
};

export { HeaderColumn };
